/** 上报接口（免登录） */
export const ATTRIBUTION_REPORT_PATH = '/user/v1/attribution/report';

/** 未指定来源时的默认值 */
export const DEFAULT_USER_SOURCE = 'official';

/** URL 中读取来源参数的参数名 */
export const USER_SOURCE_QUERY_KEY = 'userSource';

/** scheme 唤起后判定未安装、转去下载的等待时间 */
export const DEFAULT_WAKEUP_TIMEOUT = 2000;

/** 来源标识最大长度（后端约束 1~64） */
export const USER_SOURCE_MAX_LENGTH = 64;

/** 上报接口超时 */
export const REPORT_TIMEOUT = 5000;

/** WebRTC 采集内网 IP 的最长等待时间 */
export const LAN_IP_TIMEOUT = 300;

/** userAgentData 高熵值读取的最长等待时间 */
export const UA_DATA_TIMEOUT = 200;

/** 剪贴板 token 格式校验，防止把异常返回写进用户剪贴板 */
export const CLIPBOARD_TOKEN_REG = /^#dk#[0-9A-Za-z_-]+#$/;

/**
 * H5 域名 -> API 地址映射，仅用于 IIFE 独立包场景：
 * 该场景不经过 Vite 构建、拿不到各环境的 VITE_APP_BASE_URL，
 * 未显式传入 apiBase 时，按当前页面域名自动匹配，取不到则维持为空（不发请求）。
 * 与 apps/main 各 .env.* 文件中 VITE_APP_DOMAIN_NAME / VITE_APP_BASE_URL 保持同步。
 */
export const DOMAIN_API_BASE_MAP: Record<string, string> = {
  'h5-dev.docoi.cc': 'http://192.168.1.61:12301',
  'h5-test.docoi.cc': 'https://api-test.docoi.cc',
  'h5-test2.docoi.cc': 'https://api-test2.docoi.cc',
  'h5-test3.docoi.cc': 'https://api-test3.docoi.cc',
  'h5-test4.docoi.cc': 'https://api-test4.docoi.cc',
  'h5-pre.docoi.cc': 'https://api-pre.docoi.cc',
  'h5.docoi.cc': 'https://api-prod.docoi.cc'
};
